<template>
  <app-modal v-model="isDialogOpened"
             size="xs"
             :ok-text="$t('common.delete')"
             :ok-loading="deleteTableSelectionPending"
             :cancel-disabled="deleteTableSelectionPending"
             data-locator="checklist-multiple-delete-dialog"
             @cancel="closeDialog"
             @ok="deleteSelection"
  >
    <template #title>
      {{$t('project.checklist.dialogs.ChecklistDeleteSelectionDialog.title', allSelectedChecklistItems.length)}}
    </template>
    <template #body>
      <div v-if="isDeletionValidationEnabled">
        <p>{{ $t('project.checklist.dialogs.ChecklistDeleteSelectionDialog.deletionValidationText.sentence1', allSelectedChecklistItems.length) }}</p>
        <p>{{ $t('project.checklist.dialogs.ChecklistDeleteSelectionDialog.deletionValidationText.sentence2', allSelectedChecklistItems.length) }}</p>
      </div>
      <template v-else>
        <p>{{$t('project.checklist.dialogs.ChecklistDeleteSelectionDialog.text', allSelectedChecklistItems.length)}}</p>
      </template>
    </template>
  </app-modal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import { toast } from '@/common/utils/toast'
import { dialogMixin } from '@/mixins/dialogMixin'
import { DELETE_TABLE_SELECTION } from '@/store/modules/checklist/action_types'

export default {
  name: 'ChecklistDeleteSelectionDialog',
  mixins: [dialogMixin],
  computed: {
    ...mapState('room', ['currentRoom']),
    ...mapState('checklist', ['deleteTableSelectionPending']),
    ...mapGetters('checklist', ['allSelectedChecklistItems']),
    isDeletionValidationEnabled () {
      return this.currentRoom?.enableValidationChecklistItemDeletion
    },
    deleteSelectionSuccess () {
      return this.isDeletionValidationEnabled
             ? this.$t('project.project-settings.ProjectSettingsFeatures.checklist.pendingDeletion')
             : this.$t('project.checklist.dialogs.ChecklistDeleteSelectionDialog.deleteSelectionSuccess', this.allSelectedChecklistItems.length)
    },
  },
  methods: {
    ...mapActions('checklist', [DELETE_TABLE_SELECTION]),
    async deleteSelection () {
      try {
        await this.DELETE_TABLE_SELECTION()

        toast.success(this.deleteSelectionSuccess)
      } catch (error) {
        console.error(error)
        toast.error(this.$t('project.checklist.dialogs.ChecklistDeleteSelectionDialog.deleteSelectionError', this.allSelectedChecklistItems.length))
      } finally {
        this.closeDialog()
      }
    },
  },
}
</script>
